import { useDrop } from "react-dnd";
import { colors } from "../../global";

export const DropZone = ({ onDrop, children }) => {
  const [{ isOver }, drop] = useDrop(() => ({
    accept: "CHART",
    drop: (item) => onDrop(item.name),
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  }));

  return (
    <div
      ref={drop}
      className="flex items-center justify-center border-2 border-dashed rounded-lg p-4 transition-colors duration-200"
      style={{
        minHeight: 100,
        borderColor: isOver ? colors.accent : colors.darkGray,
        backgroundColor: isOver ? colors.lightAccent + "20" : colors.white,
      }}
    >
      {children || (
        <span className="text-sm" style={{ color: colors.darkGray }}>
          Drop chart here
        </span>
      )}
    </div>
  );
};
